<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { APP_CONSTANTS } from '../../../common/config/app-constants';
  import { getProductTags, getStr } from '../../../common/util';
  import TagContainer from '../../common/components/tag/TagContainer.svelte';
  import Text from '../../common/components/Text.svelte';
  import PictureTag from '../../common/lazy-components/PictureTag.svelte';
  import AtcPrice from '../../product-details/components/AddToCartPopup/AtcPrice.svelte';

  export let entry;
  const { lang } = getAppConfig();
  $: name = lang === 'en' ? entry?.product?.nameEn : entry?.product?.name;
  $: description = entry?.extraServiceAppData?.homeMaintanenceProductDescription;
</script>

<section class="c_add-to-cart-popup-item-home-maintenance">
  <div class="c_add-to-cart-popup-item-inner">
    <div class="thumb c_add-to-cart-popup-item-img">
      <!-- svelte-ignore a11y-invalid-attribute -->
      <a href="javascript:void(0);">
        <PictureTag
          image={entry?.homeMaintenanceVipEntry
            ? entry?.product?.amplienceProductBaseUrl
            : `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}${entry?.extraServiceAppData?.homeMaintanenceCategory}`}
          alt="Product-image"
          width="100%"
          height="100%"
        />
        <img
          class="icon-badge"
          src={entry?.homeMaintenanceVipEntry
            ? getStr('extra.home.service.vip.membership.icon')
            : entry?.extraServiceAppData?.homeMaintanenceIconUrl}
          alt="Icon Badge"
        />
      </a>
    </div>
    <div class="details c_add-to-cart-popup-item-details">
      <div>
        <TagContainer productTags={getProductTags(entry?.product, true)} />
        <div class="c_add-to-cart-popup-item-details-name">
          <a class="name" href="javascript:void(0);">{name}</a>
          {#if entry?.homeMaintenanceVipEntry}
            <Text key="extra.home.service.vip.membership.description" />
          {:else}
            <span>
              {description}
            </span>
          {/if}
        </div>
      </div>
      <div class="c_add-to-cart-popup-item-price">
        <AtcPrice {entry} />
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .c_add-to-cart-popup-item-home-maintenance {
    :global {
      .c_add-to-cart-popup-item-inner {
        gap: 8px;
        &:last-child {
          margin-bottom: 0;
        }

        .thumb {
          position: relative;
          width: 143px;
          height: 83px;
          border-radius: 12px;
          overflow: hidden;
          a {
            display: block;
            width: 100%;
            height: 100%;
            position: relative;

            .icon-badge {
              position: absolute;
              bottom: 2px;
              right: 2px;
              width: 24px;
              height: 24px;
              background: $primary-white;
              padding: 3px;
              border-radius: 2px;
              object-fit: contain;
            }
          }
        }
      }
      .non-vip-member {
        justify-content: space-between;
        align-items: flex-start;
      }
      .vip-container {
        min-width: 192px;
        min-height: 50px;
        .price {
          font-size: 16px;
          color: $primary-white;
          font-weight: 700;
        }
      }
    }
  }
</style>
